<template>
  <default-layout>
    <v-container>
      <!--<v-row>
        <v-col md="12">
          <v-card class="mx-auto">
            v-toolbar color="secondary" class="text__white">
              <v-app-bar-nav-icon></v-app-bar-nav-icon>
              <v-toolbar-title>Inbox</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon>
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon>mdi-checkbox-marked-circle</v-icon>
              </v-btn>
            </v-toolbar>-->
      <!--<v-list class="text-left mb-10" three-line>
              <v-list-item-group
                v-model="selected"
                multiple
                active-class="blue--text"
              >
                <template v-for="(item, index) in posts.data">
                  <v-list-item :key="item.title">
                    <template v-slot:default="{ active, toggle }">
                      <v-img
                        :src="item.media_url"
                        max-width="100"
                        class="ma-2"
                      ></v-img>
                      <v-list-item-content>
                        <v-list-item-title
                          class="ma-2"
                          v-text="item.caption"
                        ></v-list-item-title>
                        <v-list-item-subtitle class="pl-2">
                          <span>Likes: {{ item.like_count }}</span>
                          <span class="ml-4"
                            >Comments: {{ item.comments_count }}</span
                          >
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="pl-2">
                          <a :href="item.permalink" class="pr-2">
                            {{ item.permalink }}</a
                          >
                          <a :href="item.permalink">
                            <i class="fab fa-instagram"></i
                          ></a>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-icon v-if="!active" color="grey lighten-1">
                          far fa-star
                        </v-icon>
                        <v-icon v-else color="secondary">
                          fa-star
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-action>
                        <v-btn class="" small color="primary" :to="'/details/' + item.id">
                          Details
                        </v-btn>
                        <v-btn class="mt-3 pr-4 pl-4" small color="secondary" @click="toggleSelection(item.id)">
                          Select
                        </v-btn>
                      </v-list-item-action>
                    </template>
                  </v-list-item>

                  <v-divider
                    v-if="index + 1 < posts.data.length"
                    :key="index"
                  ></v-divider>
                </template>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-col>
      </v-row>-->
      <v-row>
        <v-col md="12" class="text-center">
          <v-data-table
            v-model="selected"
            :headers="headers"
            :loading="loading"
            :items="posts.data"
            item-key="id"
            hide-default-footer
            hide-default-header
            class="table-margin table-height"
            :items-per-page="perPage"
            show-select
          >
            <template v-slot:item.caption="{ item }">
              <span class="block">{{ truncate(item.caption) }}</span>
              <span class="block">Likes: 0 Comments: 0</span>
              <!--<a :href="item.permalink" class="pr-2"> {{ item.permalink }}</a>-->
              <!--<a :href="item.permalink"> <i class="fab fa-instagram"></i></a>-->
            </template>
            <template v-slot:item.media_url="{ item }">
              <v-img
                :src="item.media_url"
                max-width="100"
                class="img-dashboard"
              ></v-img>
            </template>
            <!-- <template v-slot:item.permalink="{ item }">
              <a :href="item.permalink">
                <i class="fab fa-instagram "></i>
              </a>
            </template> -->
            <template v-slot:item.id="{ item }">
              <a :href="item.permalink">
                <i class="fab fa-instagram fa-2x mr-5 insta-icon-fix"></i
              ></a>

              <v-btn
                color="secondary"
                class=""
                :to="'/details/' + item.id"
                >Details</v-btn
              >

              <!-- <a :to="'/details/' + item.id">
                <i
                  class="fas fa-search fa-2x mr-5 insta-icon-fix-mobile-screen insta-icon-fix"
                ></i
              ></a> -->
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row class="mb-12 pb-4">
        <v-col md="12">
          <v-btn color="secondary" @click="loadMore">Load More</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </default-layout>
</template>

<script>
import DefaultLayout from "@/layouts/Default";
import { mapFields } from "vuex-map-fields";
import facebookApi from "@/api/facebook.js";

export default {
  name: "DashBoard",
  components: {
    DefaultLayout
  },
  data() {
    return {
      perPage: 9999999,
      completeData: {},
      headers: [
        { text: "", value: "media_url", sortable: false },
        { text: "Post", value: "caption", sortable: false },
        //{ text: "Likes", value: "like_count", sortable: false },
        //{ text: "Comments", value: "comments_count", sortable: false },
        //{ text: "Permalink", value: "permalink", sortable: false },
        { text: "id", value: "id", sortable: false, align: "end" }
      ],
      posts: {},
      postData: {
        data: [
          {
            caption:
              "N\u00e3o tem como enjoar dessa cidade. De volta a Londres \ud83d\ude00\ud83d\udc82\u200d\u2642\ufe0f\ud83c\uddec\ud83c\udde7",
            comments_count: 1,
            like_count: 30,
            media_type: "IMAGE",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/72766536_205101823829851_1253240796920595226_n.jpg?_nc_cat=104&_nc_oc=AQkVeypSYtDga_mQOsooXB_BBW16EIm8IuvQ68TgaiImhzuRgoZ1oMoodKEM-5FakmU&_nc_ht=scontent.xx&oh=0003592e74908a0221881385118dbd7c&oe=5E4FED10",
            shortcode: "B4dHUjMJ7mz",
            permalink: "https://www.instagram.com/p/B4dHUjMJ7mz/",
            timestamp: "2019-11-04T19:16:16+0000",
            comments: {
              data: [
                {
                  username: "ondeestalili",
                  text: "Chique\ud83d\udc4f\ud83c\udffb",
                  timestamp: "2019-11-05T00:47:41+0000",
                  id: "17869401292509615"
                }
              ]
            },
            id: "17846146870734169"
          },
          {
            caption:
              "P\u00eder de Santa Monica \u00e9 uma boa op\u00e7\u00e3o para quem est\u00e1 com crian\u00e7as. Tem um pequeno parque de divers\u00f5es que as crian\u00e7as podem se divertir a vontade pagando 17 d\u00f3lares at\u00e9 7 anos ou uns 30 e poucos pata maiores. De quebra ainda \u00e9 poss\u00edvel curtir o por do sol no final da tarde. #pacificpark #piersantamonica #santamonicapier #losangeles #california #amusementpark #californiacomcrian\u00e7as #losangelescomcrian\u00e7as",
            comments_count: 0,
            like_count: 27,
            media_type: "IMAGE",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/74607445_122041115574847_3182070344586159175_n.jpg?_nc_cat=101&_nc_oc=AQkHAq-KPcW5zUxrAKkgapmTLRCshz_lBnin7YvuAoaI2OZ03ogY0-Yt7Fet6IBIsv8&_nc_ht=scontent.xx&oh=ccd1387aebdd9377e95ca5b69419d3e4&oe=5E8B565A",
            shortcode: "B4IXPkapg_g",
            permalink: "https://www.instagram.com/p/B4IXPkapg_g/",
            timestamp: "2019-10-27T17:51:21+0000",
            id: "18075036430192009"
          },
          {
            caption:
              "Final de tarde no P\u00eder de Santa Monica. #pordosol #santamonicapier #piersantamonica #pacificpark",
            comments_count: 0,
            like_count: 37,
            media_type: "CAROUSEL_ALBUM",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/75330273_697922414024997_2446225136084148111_n.jpg?_nc_cat=105&_nc_oc=AQn_lPTHUFGYYaur24gyqZhAA1FDLM1k1O9XAj8nr-d7i8NShV7_ZA_LgOdKb8aGaxU&_nc_ht=scontent.xx&oh=ff367af9082df7c10eec88d144a0b28e&oe=5E4BDEC3",
            shortcode: "B4G_UaKJG0z",
            permalink: "https://www.instagram.com/p/B4G_UaKJG0z/",
            timestamp: "2019-10-27T05:03:03+0000",
            children: {
              data: [
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/75330273_697922414024997_2446225136084148111_n.jpg?_nc_cat=105&_nc_oc=AQn_lPTHUFGYYaur24gyqZhAA1FDLM1k1O9XAj8nr-d7i8NShV7_ZA_LgOdKb8aGaxU&_nc_ht=scontent.xx&oh=ff367af9082df7c10eec88d144a0b28e&oe=5E4BDEC3",
                  id: "18105398398067809"
                },
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/73521753_111962806719180_3777689775047895948_n.jpg?_nc_cat=105&_nc_oc=AQnIozI3MmCWka4zMZp0vkv4RdixV2yGR9PBPeZ9zP6YKcIQpmCwLyCI6DVqEwzjXn0&_nc_ht=scontent.xx&oh=a970737f0fc1ec8fd38fa5bfcd63cd94&oe=5E50EF57",
                  id: "18090928687096993"
                },
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/72529471_542710176289283_6284648411070584518_n.jpg?_nc_cat=103&_nc_oc=AQmll-CsKxIp9Bx8JI13mjx-a4Mmagh9bTmRt7U1BYggWNIz_qAGb8yXh8KGM-Wl4yE&_nc_ht=scontent.xx&oh=e8d7759e8bfc561e312251b17fc6c075&oe=5E4155B1",
                  id: "17993762851276536"
                }
              ]
            },
            id: "17870469397501274"
          },
          {
            caption:
              "Pra quem est\u00e1 viajando com pequenos pela Calif\u00f3rnia tem uma op\u00e7\u00e3o bem divertida de parada. Uma fazenda de avestruz e emas onde eles podem alimentar os animais. As crian\u00e7as adoram esse contato com os bichos. Vale a parada. 5 d\u00f3lares o ingresso. \n#motorhome #solvangcalifornia #californiacomcrian\u00e7as #california \u0040ostrich_land \u0040ostrichland #avestruz",
            comments_count: 1,
            like_count: 38,
            media_type: "CAROUSEL_ALBUM",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/74889145_397102561241195_1174727241086726027_n.jpg?_nc_cat=111&_nc_oc=AQlFDtiMA5ujdR08Tj7ow2raA1LiHyNJYIbdBVUeSMdmNxwFZIfV6pQl13pEz8Z-eDA&_nc_ht=scontent.xx&oh=f8de0d1e2f44e85ff32716e2232c9f22&oe=5E4CF4EE",
            shortcode: "B4DgqT_plKh",
            permalink: "https://www.instagram.com/p/B4DgqT_plKh/",
            timestamp: "2019-10-25T20:37:26+0000",
            children: {
              data: [
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/74889145_397102561241195_1174727241086726027_n.jpg?_nc_cat=111&_nc_oc=AQlFDtiMA5ujdR08Tj7ow2raA1LiHyNJYIbdBVUeSMdmNxwFZIfV6pQl13pEz8Z-eDA&_nc_ht=scontent.xx&oh=f8de0d1e2f44e85ff32716e2232c9f22&oe=5E4CF4EE",
                  id: "18001797523265983"
                },
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/73512625_173729293777716_3667279031208176671_n.jpg?_nc_cat=107&_nc_oc=AQnUGyp3_vjIsYjRmr2l82SMy0Ey0m2yaN_CCx_NdLSA9wnj9aOEfLkIsQWfVFrvWvQ&_nc_ht=scontent.xx&oh=841b17728908a5289746341dc01b01bd&oe=5E50D4DE",
                  id: "17843065387744055"
                }
              ]
            },
            comments: {
              data: [
                {
                  username: "leticia_lermann",
                  text: "Lindos!! \u2764\ufe0f\ud83d\ude0d",
                  timestamp: "2019-10-25T20:58:37+0000",
                  id: "17876995849463523"
                }
              ]
            },
            id: "17847856939719411"
          },
          {
            caption:
              "Descendo pela highway 1 em dire\u00e7\u00e3o a Los Angeles \u00e9 poss\u00edvel parar em Monterey. O centro \u00e9 muito legal de caminhar. Varias lojinhas, restaurantes e uma loja de chocolates \u0040ghirardelli\n#monterey #california #motorhome",
            comments_count: 0,
            like_count: 26,
            media_type: "CAROUSEL_ALBUM",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/73016968_549341935839268_4880250840267953935_n.jpg?_nc_cat=111&_nc_oc=AQk7IUmL7DjwmBY6BpGC0KNkPoRHQIx7kVe_73ezbbSee7C3FgjkmpFEBUK239wAFMg&_nc_ht=scontent.xx&oh=f911edba6f8440ca401d57d3daad5556&oe=5E4B0E60",
            shortcode: "B4B2zArJRre",
            permalink: "https://www.instagram.com/p/B4B2zArJRre/",
            timestamp: "2019-10-25T05:12:23+0000",
            children: {
              data: [
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/73016968_549341935839268_4880250840267953935_n.jpg?_nc_cat=111&_nc_oc=AQk7IUmL7DjwmBY6BpGC0KNkPoRHQIx7kVe_73ezbbSee7C3FgjkmpFEBUK239wAFMg&_nc_ht=scontent.xx&oh=f911edba6f8440ca401d57d3daad5556&oe=5E4B0E60",
                  id: "17867458288514204"
                },
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/75225522_400536524220394_29593226555257984_n.jpg?_nc_cat=110&_nc_oc=AQkZO0_gJ8zxnJOgLERr9R-Abrb61Ea9_qlwJMqAP5kPryuzqpoELjOfsQ6wiCCKT3U&_nc_ht=scontent.xx&oh=652a1c177bf0a5517da0368fdb33ec53&oe=5E49B6B4",
                  id: "18103776817070439"
                }
              ]
            },
            id: "17897158192403669"
          },
          {
            caption:
              "Golden Gate - S\u00e3o Francisco. Como dica a gente n\u00e3o aconselha a viajar de motorhome por SF. As ruas da cidade s\u00e3o estreitas, n\u00e3o se acha lugar para estacionar e os campings s\u00e3o absurdamente caros. Tamb\u00e9m existem muitos casos de arrombamento de motorhome para roubar as coisas. Ent\u00e3o n\u00e3o \u00e9 um bom lugar para esse tipo de viagem. \n#goldengatebridge #saofrancisco #motorhome",
            comments_count: 0,
            like_count: 35,
            media_type: "IMAGE",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/74408967_781535348945028_8407871440312383122_n.jpg?_nc_cat=100&_nc_oc=AQn6ENrzbyuu_nQ75D3JVJ2PeDKax8u3OaWnS-5XCsoVjh4A-0O7MlqzXdVVkG_MN6I&_nc_ht=scontent.xx&oh=f58985ef5e30e517892f44b3afb5e550&oe=5E412D51",
            shortcode: "B3_UGfTJGsp",
            permalink: "https://www.instagram.com/p/B3_UGfTJGsp/",
            timestamp: "2019-10-24T05:30:43+0000",
            id: "18108979924040930"
          },
          {
            caption:
              "#yosemite #yosemitenationalpark #motorhome #motorhomeeua #motorhomeusa",
            comments_count: 1,
            like_count: 53,
            media_type: "CAROUSEL_ALBUM",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/71676651_164598614654852_4828578083208943394_n.jpg?_nc_cat=102&_nc_oc=AQltmiziufRDk4oEUlAL5F69YKHqoL9lpdtmZ20foM1dZgIvHHw2meioN5U9_U9LrDM&_nc_ht=scontent.xx&oh=9032a38a3438fa31f30d70c1b209e19e&oe=5E4E3F22",
            shortcode: "B38uLuZprEy",
            permalink: "https://www.instagram.com/p/B38uLuZprEy/",
            timestamp: "2019-10-23T05:20:55+0000",
            children: {
              data: [
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/71676651_164598614654852_4828578083208943394_n.jpg?_nc_cat=102&_nc_oc=AQltmiziufRDk4oEUlAL5F69YKHqoL9lpdtmZ20foM1dZgIvHHw2meioN5U9_U9LrDM&_nc_ht=scontent.xx&oh=9032a38a3438fa31f30d70c1b209e19e&oe=5E4E3F22",
                  id: "17853385723623127"
                },
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/73393279_3056350507769784_8898382696356702182_n.jpg?_nc_cat=110&_nc_oc=AQlUFCXlf7tzAGFpUEd-xIqtLsdvtgW1K02rSkGc6MdYDQS6VwSbTvhYCJ_ot4T6WHk&_nc_ht=scontent.xx&oh=e86f4ecfd17bf7e69d2e3e2e934ed38a&oe=5E548A7C",
                  id: "17968240159292565"
                },
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/75483247_2497786633839398_7502140079856468835_n.jpg?_nc_cat=108&_nc_oc=AQlMJ8sEZMZIMJMLJPMrTne-FsLxuBVqWwSq1U1meVWSBBl8oaSaVAu8q0lndkaI0Po&_nc_ht=scontent.xx&oh=7f5bfbc40f941e7ced67fe377ee4a394&oe=5E52A945",
                  id: "17845127959731274"
                },
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/72572590_142494270458369_8874137948075197903_n.jpg?_nc_cat=111&_nc_oc=AQnbjb7UNSTNwUUvXlz1ZKODfzP9IiHSUPHbZLiZOE2y9TsKnXJJrhdC2_RtJ39wtTs&_nc_ht=scontent.xx&oh=e3dfadac94c31b1b08935258bfa575c0&oe=5E5A4154",
                  id: "17848892821679457"
                },
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/74698391_547371179409408_4210125816067264189_n.jpg?_nc_cat=111&_nc_oc=AQmVof5A_WgIIuSwvaM092AE8GM8d8IGG69Z2l0NWHvTFkktOL7KmDWZAEAMmm5anSA&_nc_ht=scontent.xx&oh=b4ad07f4ac8be45bdbe70f7d7e7e4388&oe=5E46845B",
                  id: "17851100644649952"
                }
              ]
            },
            comments: {
              data: [
                {
                  username: "gorska.krystyna",
                  text: "\ud83d\ude03",
                  timestamp: "2019-10-23T06:53:22+0000",
                  id: "18007536520258432"
                }
              ]
            },
            id: "17925828520326432"
          },
          {
            caption:
              "Nos EUA \u00e9 bem seguro e tranquilo de fazer free camping com o motor home. Nesse caso nos est\u00e1vamos indo em dire\u00e7\u00e3o a Yosemite e resolvemos dormir no caminho. Paramos nessa pequena cidade, encontramos uma rua tranquila, estacionamos e ali mesmo dormimos para seguir viagem no dia seguinte. \n#motorhomecalifornia #motorhomeeua #freecamping",
            comments_count: 3,
            like_count: 31,
            media_type: "IMAGE",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/75299406_688763234943132_7403168747427957743_n.jpg?_nc_cat=103&_nc_oc=AQl_Dgq6CRJR-HHKWdQZTh-nrJ_ikf7AESkpT-wWRmLks_C5iOV2VnSOye18uXlS3iM&_nc_ht=scontent.xx&oh=36ff5eba217471ef25de35b8ce6731b8&oe=5E4ECD71",
            shortcode: "B38ofp2pDcI",
            permalink: "https://www.instagram.com/p/B38ofp2pDcI/",
            timestamp: "2019-10-23T04:31:12+0000",
            comments: {
              data: [
                {
                  username: "penaestradademotorhome",
                  text:
                    "\ud83d\udc4f\ud83c\udffb\ud83d\udc4f\ud83c\udffb\ud83d\udc4f\ud83c\udffb",
                  timestamp: "2019-10-23T12:26:35+0000",
                  id: "18024823150242287"
                },
                {
                  username: "denicristianrs",
                  text:
                    "Para, aqui na tinga eh bem tranquilo \ud83d\ude02\ud83d\ude02\ud83d\ude02",
                  timestamp: "2019-10-23T05:17:04+0000",
                  id: "17926071220329760"
                }
              ]
            },
            id: "17887380445430643"
          },
          {
            caption:
              "Passeio imperd\u00edvel por dentro do Antelope Canyon. Indescrit\u00edvel as cores que a gente v\u00ea. \n#antelopecanyon #lowerantelopecanyon #kenstours #pagearizona #motorhome",
            comments_count: 2,
            like_count: 37,
            media_type: "CAROUSEL_ALBUM",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/71044293_2360497680867138_135439897361526405_n.jpg?_nc_cat=103&_nc_oc=AQkibuzIcXAhqBHtxBCRjsq51sEeQlbUaZU6KYlNT6VgFdyJPcFfnUW8GzH11NelNxA&_nc_ht=scontent.xx&oh=0d84d03e1f9fcb77923cd390348525f4&oe=5E5AEFBB",
            shortcode: "B3ykmgSJ8k5",
            permalink: "https://www.instagram.com/p/B3ykmgSJ8k5/",
            timestamp: "2019-10-19T06:44:47+0000",
            children: {
              data: [
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/71044293_2360497680867138_135439897361526405_n.jpg?_nc_cat=103&_nc_oc=AQkibuzIcXAhqBHtxBCRjsq51sEeQlbUaZU6KYlNT6VgFdyJPcFfnUW8GzH11NelNxA&_nc_ht=scontent.xx&oh=0d84d03e1f9fcb77923cd390348525f4&oe=5E5AEFBB",
                  id: "17861997763546834"
                },
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/74645243_2690809167675617_5799585813172587245_n.jpg?_nc_cat=101&_nc_oc=AQkWs9xI9v27UsyZD_1tFsQNoGGsNV0CeC8asWABqM4UuDxdsizRfkMttkO84ogFj_Y&_nc_ht=scontent.xx&oh=766a76d55fae3e7304118c631b4cadf2&oe=5E449098",
                  id: "17846570557707641"
                }
              ]
            },
            comments: {
              data: [
                {
                  username: "viviszuchman",
                  text: "Vou querer dica \ud83d\ude09",
                  timestamp: "2019-10-20T17:41:59+0000",
                  id: "18026160565230792"
                }
              ]
            },
            id: "17980368034286210"
          },
          {
            caption:
              "Grand Canyon. Lugar sensacional. As fotos talvez n\u00e3o mostrem toda a sua beleza. \ud83d\udc4f\ud83d\udc4f\u26f0\n#grandcanyon #arizona #motorhome \u0040grandcanyonnps",
            comments_count: 0,
            like_count: 45,
            media_type: "CAROUSEL_ALBUM",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/72480004_139172584144272_6539723465703215933_n.jpg?_nc_cat=106&_nc_oc=AQlVuUkti8eWRgNIOPLaTuzxuvR5O6W9wo3tS9rUqV5RLQwdps7fQRN2mSJ4VyIIYUE&_nc_ht=scontent.xx&oh=ed8ec7889414d906cdb4be52a0218e9c&oe=5E50E068",
            shortcode: "B3tQG8YpGRJ",
            permalink: "https://www.instagram.com/p/B3tQG8YpGRJ/",
            timestamp: "2019-10-17T05:09:30+0000",
            children: {
              data: [
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/72480004_139172584144272_6539723465703215933_n.jpg?_nc_cat=106&_nc_oc=AQlVuUkti8eWRgNIOPLaTuzxuvR5O6W9wo3tS9rUqV5RLQwdps7fQRN2mSJ4VyIIYUE&_nc_ht=scontent.xx&oh=ed8ec7889414d906cdb4be52a0218e9c&oe=5E50E068",
                  id: "18086835007128809"
                },
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/71038410_2402576773335734_458297725873129314_n.jpg?_nc_cat=107&_nc_oc=AQkSbqOLaqWRB73BvQvIERRPohkejPre-n9b3EudDNCuO4OBiw7hJGl8OL6zQPIse5o&_nc_ht=scontent.xx&oh=7e41b3d7dc449fd2549fb5b9b5899041&oe=5E57FA91",
                  id: "17855062711604703"
                },
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/71116761_158906968512726_7230883605606476922_n.jpg?_nc_cat=101&_nc_oc=AQkFHig8RCvulQr1CcYRTSMysGKL5svIuGM9fM-EvHQN7LAyZlbAj2IN5znQs2AY8WA&_nc_ht=scontent.xx&oh=238d12b8d9b4223f72ac3fe51016d9eb&oe=5E60CCBD",
                  id: "18107901886040070"
                },
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/70497716_150356302876352_8859456642148057403_n.jpg?_nc_cat=102&_nc_oc=AQlIOEChLkJPLVcAGt9pO_u76lLuOr7-7BWhsfeZOFLS3lazxyeJ2pGfcFXYz5xpEms&_nc_ht=scontent.xx&oh=fec78b1696531ae922c189e8d5df8547&oe=5E8B6FDC",
                  id: "18038861575207214"
                }
              ]
            },
            id: "18070670788156441"
          },
          {
            caption:
              "Todos os dias \u00e9 poss\u00edvel ver um show das fontes de \u00e1gua do hotel Bellagio. Vale muito a pena. A cada meia hora come\u00e7ando \u00e0s 15h em dias de semana. \n#lasvegas #bellagio",
            comments_count: 3,
            like_count: 45,
            media_type: "CAROUSEL_ALBUM",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/71178840_2530969710343212_7587437422844753405_n.jpg?_nc_cat=102&_nc_oc=AQknutEX8o8vRmqABlLRgxFDZ1v8Awnlxxk6uvgg6y_Pp442Fe4myIP6m5zXBmpHMm0&_nc_ht=scontent.xx&oh=c726ea3891ba011eaeb29416144a4e81&oe=5E46C60A",
            shortcode: "B3qHLtpJZJs",
            permalink: "https://www.instagram.com/p/B3qHLtpJZJs/",
            timestamp: "2019-10-15T23:53:47+0000",
            children: {
              data: [
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/71178840_2530969710343212_7587437422844753405_n.jpg?_nc_cat=102&_nc_oc=AQknutEX8o8vRmqABlLRgxFDZ1v8Awnlxxk6uvgg6y_Pp442Fe4myIP6m5zXBmpHMm0&_nc_ht=scontent.xx&oh=c726ea3891ba011eaeb29416144a4e81&oe=5E46C60A",
                  id: "18007880434248870"
                },
                {
                  media_type: "VIDEO",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t50.2886-16/73173874_441066876531753_6620920649050300281_n.mp4?_nc_cat=107&_nc_oc=AQkB46Hiuieva-ZeTL17wBiXA8OvDxF0wM8W65gu11_k4--Ys4_VozUSAZW1uasAdQU&_nc_ht=scontent.xx&oh=7139fbc8a03c17063f9ab847b4cafec0&oe=5E4B8151",
                  id: "18073499299131685"
                }
              ]
            },
            comments: {
              data: [
                {
                  username: "michediamante",
                  text: "\u00c9 lindo mesmo!",
                  timestamp: "2019-10-16T01:55:58+0000",
                  id: "17846128555715104"
                },
                {
                  username: "plaxen84",
                  text: "This looks really beautiful \ud83d\ude4c\ud83e\udd29",
                  timestamp: "2019-10-16T00:01:59+0000",
                  id: "17866231423508355"
                }
              ]
            },
            id: "17987316385301143"
          },
          {
            caption:
              "E a nossa primeira noite foi na estrada entre Los Angeles e Las Vegas. Descansar um pouco pra amanh\u00e3 de manh\u00e3 seguir viagem.\n#motorhome #california #lasvegas",
            comments_count: 1,
            like_count: 26,
            media_type: "IMAGE",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/73387336_2418006965105248_8322608661253900777_n.jpg?_nc_cat=111&_nc_oc=AQnHRPmq19EqhYe58LqPO-MsMaDF207ztQoI-EbShu3C6nvp8H5TEn-tDGyQBQXFDTE&_nc_ht=scontent.xx&oh=0992161c4b6afe541d82a2e0c84a79ca&oe=5E4C4DE6",
            shortcode: "B3oC0JWp08W",
            permalink: "https://www.instagram.com/p/B3oC0JWp08W/",
            timestamp: "2019-10-15T04:37:08+0000",
            comments: {
              data: [
                {
                  username: "ondeestalili",
                  text:
                    "\ud83d\ude4c\ud83c\udffb\ud83d\ude4c\ud83c\udffb\ud83d\ude4c\ud83c\udffb",
                  timestamp: "2019-10-15T04:39:12+0000",
                  id: "17890362274424480"
                }
              ]
            },
            id: "17895347908397262"
          },
          {
            caption:
              "Reino da aventura. Muita divers\u00e3o pra crian\u00e7ada. Playground, arvorismo, tirolesa\n#reinoaventura #iguatemi #iguatemipoa",
            comments_count: 0,
            like_count: 27,
            media_type: "CAROUSEL_ALBUM",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/69721648_374066736815418_5739271711372174225_n.jpg?_nc_cat=105&_nc_oc=AQmhEyKb-44xnAJUsZXQ86bF1IUBIxZDRHpSPre64cALmyXeXNpflEz13tlPEymLEQQ&_nc_ht=scontent.xx&oh=83beb9eda40d0a7b21eeb0390d84902b&oe=5E576FCA",
            shortcode: "B3Fv4tIJ6g_",
            permalink: "https://www.instagram.com/p/B3Fv4tIJ6g_/",
            timestamp: "2019-10-01T20:57:34+0000",
            children: {
              data: [
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/69721648_374066736815418_5739271711372174225_n.jpg?_nc_cat=105&_nc_oc=AQmhEyKb-44xnAJUsZXQ86bF1IUBIxZDRHpSPre64cALmyXeXNpflEz13tlPEymLEQQ&_nc_ht=scontent.xx&oh=83beb9eda40d0a7b21eeb0390d84902b&oe=5E576FCA",
                  id: "18023592505239177"
                },
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/70539892_766634383785729_1531851487595068529_n.jpg?_nc_cat=108&_nc_oc=AQkmGYAqmSGAJy-Tk5TVtAW4oCExE0Z1M7Wt65YemvTkNaf3HUsJQFVytNJX4SS_4us&_nc_ht=scontent.xx&oh=93940a309a2e8d7d8c508b9e9dc55236&oe=5E57DF06",
                  id: "18085338565097274"
                }
              ]
            },
            id: "17897641501378188"
          },
          {
            caption:
              "Vai ter costel\u00e3o pro almo\u00e7o \ud83d\ude0b\nPlaza caldas da imperatriz \u00e9 um hotel que fica em Santo Amaro da imperatriz. Distante 5h de Porto Alegre oferece uma \u00f3tima experi\u00eancia familiar. Atividades de recrea\u00e7\u00e3o para crian\u00e7as a partir dos 4 anos at\u00e9 \u00e0 idade adulta. Piscinas com \u00e1gua termal e \u00f3timas refei\u00e7\u00f5es. \n#churrasco #costelao #plazacaldasdaimperatrizresortespa #plazahoteis #santoamarodaimperatrizsc",
            comments_count: 5,
            like_count: 31,
            media_type: "IMAGE",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/69312085_170156650726277_2616654303422315477_n.jpg?_nc_cat=105&_nc_oc=AQmfs9gzwNe51__o4sL9unNb8X0eLLkXzFQWA4ZFKRs4Fa6v7q_HIE2aIycxF18G8ZE&_nc_ht=scontent.xx&oh=c02d147ff3ca39b687adbddf2af0fd72&oe=5E44FD82",
            shortcode: "B2otcUYpDi-",
            permalink: "https://www.instagram.com/p/B2otcUYpDi-/",
            timestamp: "2019-09-20T14:18:14+0000",
            comments: {
              data: [
                {
                  username: "carlos_dos_santos_cantor",
                  text:
                    "Paaaa onde estava eu que n\u00e3o vi isso \ud83d\ude25\ud83d\ude25\ud83d\ude25",
                  timestamp: "2019-09-20T15:45:04+0000",
                  id: "18101670616041717"
                },
                {
                  username: "cellofigueiredo",
                  text: "Bom descanso, Rafa!",
                  timestamp: "2019-09-20T14:34:16+0000",
                  id: "17866330030483866"
                }
              ]
            },
            id: "17920156546336533"
          },
          {
            caption:
              "Legoland em Windsor. Um belo passeio de um dia inteiro para fazer com as crian\u00e7as. Tudo que \u00e9 tipo de atra\u00e7\u00e3o com legos, brinquedos pra montar, pra andar, playground e tamb\u00e9m parte molhada. \nPela nossa experi\u00eancia o parque \u00e9 mais indicado para crian\u00e7as entre 5 e 9 anos. \nVoc\u00ea pode chegar facilmente se trem e depois \u00f4nibus ou diretamente de \u00f4nibus saindo de Londres. \nExistem dias com promo\u00e7\u00f5es de pagar um ingresso e entrar duas pessoas. \nAinda pode aproveitar pra conhecer a cidade de Windsor e o seu castelo. \n#legoland #legolandwindsor #lego #windsor #amusementpark #viajandocomcriancas #london #londres \ud83c\uddec\ud83c\udde7",
            comments_count: 1,
            like_count: 38,
            media_type: "CAROUSEL_ALBUM",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/69882127_722798628141767_108413788579400776_n.jpg?_nc_cat=106&_nc_oc=AQlqhgaAztGuCCWXjGVRicEEpIo5f7S-suY1HwRb5UsawDkudAtpwpAeiyCBl3dpbys&_nc_ht=scontent.xx&oh=c6750d5b83ba138b983334943af7dc9f&oe=5E41E83C",
            shortcode: "B2VXOKtJgX9",
            permalink: "https://www.instagram.com/p/B2VXOKtJgX9/",
            timestamp: "2019-09-13T01:58:29+0000",
            children: {
              data: [
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/69882127_722798628141767_108413788579400776_n.jpg?_nc_cat=106&_nc_oc=AQlqhgaAztGuCCWXjGVRicEEpIo5f7S-suY1HwRb5UsawDkudAtpwpAeiyCBl3dpbys&_nc_ht=scontent.xx&oh=c6750d5b83ba138b983334943af7dc9f&oe=5E41E83C",
                  id: "17851977943577318"
                },
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/70330060_367725997463028_6007736742872760401_n.jpg?_nc_cat=109&_nc_oc=AQlfYS2IwuGANEfbfiWT7cV11thPvZGQNSHTGPFjiudtLf5BY3SvpzQolrGwju93Dlk&_nc_ht=scontent.xx&oh=2ef6eab5ce5b5834f6a056e541bd24c8&oe=5E898193",
                  id: "17881617940426492"
                },
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/69024257_385553179010647_3162493194775284761_n.jpg?_nc_cat=107&_nc_oc=AQnoiRqIIyrlQ-gB20JLWqVs17IEX3phYsJfyzOdb5ZfrZNXtqL27XYiXpwcEjF1cTE&_nc_ht=scontent.xx&oh=892d50888469714892dc21723b4dc467&oe=5E60565D",
                  id: "17973618970287342"
                }
              ]
            },
            comments: {
              data: [
                {
                  username: "umavolta",
                  text: "Bem bacana pra se divertir! \ud83d\ude04\u2764\ufe0f",
                  timestamp: "2019-09-13T18:49:19+0000",
                  id: "18081406387096773"
                }
              ]
            },
            id: "17874229414452409"
          },
          {
            caption:
              "Uma experi\u00eancia bem agrad\u00e1vel almo\u00e7ar e passar algumas horas no restaurante Berga Motta. Boa comida. Trilhas at\u00e9 a Cachoeira, rede para descansar, espa\u00e7o para as crian\u00e7as correrem e brincar e outras atividades. Saindo do centro de gramado n\u00e3o leva mais do que 15 min at\u00e9 ali. #gramado #serragaucha #bergamotta \u0040ecoparque_sperry #ecoparquesperry",
            comments_count: 3,
            like_count: 45,
            media_type: "IMAGE",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/68831333_2418437634943218_3030701623410978576_n.jpg?_nc_cat=109&_nc_oc=AQk8CTDl3K3irVIsmbjgYM4F5LNU5Ci2F4dCXmq2NKpDGp57QTsnKor_9hmeqChr-WQ&_nc_ht=scontent.xx&oh=9024f4a20fc0aa92c8f43b3e12da5b33&oe=5E50E232",
            shortcode: "B2UzKP-pVjh",
            permalink: "https://www.instagram.com/p/B2UzKP-pVjh/",
            timestamp: "2019-09-12T20:43:23+0000",
            comments: {
              data: [
                {
                  username: "ecoparque_sperry",
                  text: "\ud83d\ude0b",
                  timestamp: "2019-09-12T23:54:30+0000",
                  id: "17850636133579124"
                },
                {
                  username: "ecoparque_sperry",
                  text: "\u0040berga_motta",
                  timestamp: "2019-09-12T23:54:20+0000",
                  id: "17999931178259162"
                }
              ]
            },
            id: "17869457146463277"
          },
          {
            caption:
              "Esse ano tive o prazer de estar em Londres durante o torneio de Wimbledon. Que experi\u00eancia bacana. Muito legal toda a atmosfera do evento. Vale muito a pena. \ud83c\udfbe #wimbledon2019\ud83c\udfbe #wimblendon #london #londres #atp",
            comments_count: 8,
            like_count: 21,
            media_type: "IMAGE",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/69667987_127815191907211_726456268512876646_n.jpg?_nc_cat=104&_nc_oc=AQlMd1e9r8E2JgdaMO-5J1H6Ir6qYSjYQ1mTugzKq4107jcA23ZtvPnBIofvSYf_5PY&_nc_ht=scontent.xx&oh=39e231e0060df28221958b956a21bb25&oe=5E8CC066",
            shortcode: "B2UymNQJ_-0",
            permalink: "https://www.instagram.com/p/B2UymNQJ_-0/",
            timestamp: "2019-09-12T20:38:28+0000",
            comments: {
              data: [
                {
                  username: "andre_steren_",
                  text:
                    "O que t\u00e1 acontecendo contigo?? Fotos nost\u00e1lgicas??? Te vi hoje pelo bom fim comendo xis bacon da lancheria!! Hahaha",
                  timestamp: "2019-09-13T00:10:51+0000",
                  id: "18069164875088386"
                },
                {
                  username: "viviszuchman",
                  text: "Ihh, isso foi no verao, ja ta no passado heheh",
                  timestamp: "2019-09-12T20:43:55+0000",
                  id: "18058850008167823"
                }
              ]
            },
            id: "17855901622538559"
          },
          {
            caption:
              "Pra quem curte aventura radical o \u0040parquegasper \u00e9 uma \u00f3tima op\u00e7\u00e3o. Bungee jump, tirolesa, rapel, arvorismo, Superman, trilha de quadriciclo e etc. aventura que n\u00e3o acaba mais. Vale um dia l\u00e1 e com certeza ser\u00e1 de muita divers\u00e3o. #parquegasper #parquegasperdeaventura #bentogoncalves #bentogoncalvesrs #turismodeaventura #serragaucha",
            comments_count: 2,
            like_count: 25,
            media_type: "IMAGE",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/66624200_471789003399440_4904274498494745658_n.jpg?_nc_cat=104&_nc_oc=AQlA9sayEgQ2rBSMT09eR1lyDmSYEGB9PEPYQgfvz-vUqX-9HmrAJ4s9YYW4xGUKiJw&_nc_ht=scontent.xx&oh=dc6dacc6ce5a75d290f3aa99a0aa09d9&oe=5E55ED87",
            shortcode: "B1AaZ9jpwCL",
            permalink: "https://www.instagram.com/p/B1AaZ9jpwCL/",
            timestamp: "2019-08-11T02:10:52+0000",
            comments: {
              data: [
                {
                  username: "umavolta",
                  text:
                    "Deve ser um passeio e tanto! Pena que n\u00e3o sou muito da aventura! \ud83d\ude04\u2764\ufe0f",
                  timestamp: "2019-08-11T11:22:59+0000",
                  id: "18022161937214826"
                }
              ]
            },
            id: "18091748614043821"
          },
          {
            caption:
              "Paris reserva muitas surpresas para os pequenos. Que tal deixar seus filhos andarem pela parede ao lado do Sena? Balan\u00e7os, espa\u00e7os pra jogar futebol e muitas outras op\u00e7\u00f5es para as crian\u00e7as durante o passeio. #paris #pariscomcrian\u00e7as #fran\u00e7a #iphonexs #hoteldevilleparis #hoteldeville",
            comments_count: 2,
            like_count: 34,
            media_type: "IMAGE",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/61365999_163405928027677_6721015842351039385_n.jpg?_nc_cat=110&_nc_oc=AQmG8kOVJp0jnMx2aNwaLUTER_gdwE-44vOIhjtlBXazxPcpv4P1LxaR0VUQ-dB-glU&_nc_ht=scontent.xx&oh=d0aac8b9c1ba43ae1298d6bd6dc73d9c&oe=5E4F4932",
            shortcode: "Byf-hwLJ9jK",
            permalink: "https://www.instagram.com/p/Byf-hwLJ9jK/",
            timestamp: "2019-06-09T18:48:47+0000",
            comments: {
              data: [
                {
                  username: "gabicastanheira",
                  text:
                    "\u00c9 \u201cuma atra\u00e7\u00e3o\u201d fixa? Ou tempor\u00e1ria?",
                  timestamp: "2019-06-20T15:10:50+0000",
                  id: "18039698485165712"
                }
              ]
            },
            id: "17852006089451774"
          },
          {
            caption:
              "Um dos poucos castelos que ainda mant\u00e9m o fosso e porta elevadi\u00e7a. Vale a pena a visita. #chateauvincennes #paris #castelos #pariscomcrian\u00e7as #doleitorzh #iphonexs",
            comments_count: 0,
            like_count: 44,
            media_type: "IMAGE",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/61118030_873805332960697_1774261053157901072_n.jpg?_nc_cat=102&_nc_oc=AQlBugDiEbmRijjiEkhANNdL42cGyKofwc6SJsHWXT5TmPwaCjsv90VVl5SkPx59ni4&_nc_ht=scontent.xx&oh=3a6d56fbf9ab52571fe02c68558df014&oe=5E8C6316",
            shortcode: "Byc2zKWJLWP",
            permalink: "https://www.instagram.com/p/Byc2zKWJLWP/",
            timestamp: "2019-06-08T13:43:32+0000",
            id: "18073369348055963"
          },
          {
            caption:
              "Playmobil funpark. Em dias que o tempo n\u00e3o estiver muito bom \u00e9 poss\u00edvel levar as crian\u00e7as pra brincar em parque coberto cheio de playmobil. Custo de 3 euros. #paris #pariscomcrian\u00e7as #pariscomcriancas #playmobil #playmobilfunpark",
            comments_count: 3,
            like_count: 31,
            media_type: "CAROUSEL_ALBUM",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/64248012_2265369320459561_1431172029355520353_n.jpg?_nc_cat=104&_nc_oc=AQkt4hntdfeLDS9WYiXwctBRSLAl2DvKKk5_D-wszXF2DxX0YxDQ4xRNIWPK8LkrweU&_nc_ht=scontent.xx&oh=f2636e726ff90a3f633f83dbfdca5e09&oe=5E5D781F",
            shortcode: "ByZ_hu4J-IZ",
            permalink: "https://www.instagram.com/p/ByZ_hu4J-IZ/",
            timestamp: "2019-06-07T11:02:04+0000",
            children: {
              data: [
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/64248012_2265369320459561_1431172029355520353_n.jpg?_nc_cat=104&_nc_oc=AQkt4hntdfeLDS9WYiXwctBRSLAl2DvKKk5_D-wszXF2DxX0YxDQ4xRNIWPK8LkrweU&_nc_ht=scontent.xx&oh=f2636e726ff90a3f633f83dbfdca5e09&oe=5E5D781F",
                  id: "17871170272387247"
                },
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/61698858_2419957508236530_6168651097167249064_n.jpg?_nc_cat=108&_nc_oc=AQlZWjTg-kbTxzOrLGpTHrcbfhZcEYv5RgGkzTJWNaYt4FS74mKwcc-7k7y2nWTMnfc&_nc_ht=scontent.xx&oh=7b5d087f3be06c6af81b7d8c43b96f58&oe=5E4FEDB0",
                  id: "17903278174319155"
                }
              ]
            },
            comments: {
              data: [
                {
                  username: "ondeestalili",
                  text: "Bohhh!!! Me leva \ud83d\ude0d",
                  timestamp: "2019-06-07T16:44:09+0000",
                  id: "17970958669265694"
                }
              ]
            },
            id: "17996537671239492"
          },
          {
            caption:
              "Boulevard la\u00e7ador em Porto Alegre \u00e9 um lugar muito legal para passar umas horas. Tem um grande espa\u00e7o para as crian\u00e7as brincarem, campo pra jogar bola, restaurantes, ver os avi\u00f5es pousando e decolando e ainda um antigo modelo de um avi\u00e3o da Varig. Alguns dias por m\u00eas \u00e9 poss\u00edvel visitar o avi\u00e3o por dentro. #boulevardla\u00e7ador #portoalegre #varig",
            comments_count: 1,
            like_count: 36,
            media_type: "IMAGE",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/59843131_2039839506126678_4563087898773456262_n.jpg?_nc_cat=105&_nc_oc=AQk0b_84KbksegXu-PPfLEDWozE0Tg3M9v8zZ7AdhytZITE7EC898sLZ2QdtOigoOqg&_nc_ht=scontent.xx&oh=c4d09475f994517767e69a7241d42d8e&oe=5E8BAF1D",
            shortcode: "BxTXR5LJr9y",
            permalink: "https://www.instagram.com/p/BxTXR5LJr9y/",
            timestamp: "2019-05-11T00:43:33+0000",
            comments: {
              data: [
                {
                  username: "deborahmuffarrej",
                  text:
                    "Varig, Varig, Varig, Cruzeiro, Cruzeiro..... Adorava a propaganda deles e tamb\u00e9m viajei muitoooo por eles. Saudades \ud83d\udc99\ud83d\udc99\ud83d\udc99",
                  timestamp: "2019-05-11T01:04:29+0000",
                  id: "18063868189026227"
                }
              ]
            },
            id: "17969282293258707"
          },
          {
            caption:
              "Pra quem vem pra Londres nessa \u00e9poca n\u00e3o pode deixar de aproveitar o Winter Wonderland. Lugar para se divertir, assistir shows, comer e muito mais. Divers\u00e3o para todas as idades. Entrada gratuita para passear, pagando apenas pelas atra\u00e7\u00f5es que utilizar. #london #vgdicas #winterwonderland #londrescomcriancas #viajandocomcrian\u00e7as #iceskating #amusementpark #parquedediversoes #gopro #doleitorzh #londonwithchildren \u0040viagens__e__dicas",
            comments_count: 0,
            like_count: 67,
            media_type: "CAROUSEL_ALBUM",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/45898735_353363651909233_8605105103415956566_n.jpg?_nc_cat=108&_nc_oc=AQkESJfkDRFfhiG9R8TUjcxlrsxumziiAG9eXsb93Qv33JfTLRGVTXsH_uSTWFiaaGA&_nc_ht=scontent.xx&oh=1a8d979889e46c7e7f35577ea2802b16&oe=5E470678",
            shortcode: "Bq-W5g5lJh7",
            permalink: "https://www.instagram.com/p/Bq-W5g5lJh7/",
            timestamp: "2018-12-04T17:47:48+0000",
            children: {
              data: [
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/45898735_353363651909233_8605105103415956566_n.jpg?_nc_cat=108&_nc_oc=AQkESJfkDRFfhiG9R8TUjcxlrsxumziiAG9eXsb93Qv33JfTLRGVTXsH_uSTWFiaaGA&_nc_ht=scontent.xx&oh=1a8d979889e46c7e7f35577ea2802b16&oe=5E470678",
                  id: "17998730659077818"
                },
                {
                  media_type: "IMAGE",
                  media_url:
                    "https://scontent.xx.fbcdn.net/v/t51.2885-15/46784200_352257885350902_7830100288022870750_n.jpg?_nc_cat=101&_nc_oc=AQmVtDu6vPgHnE4jdASBtuWrd4XLWXzQ2JZUh4dm2b9LrEb1w9qj8xYHLwcqjE81qGM&_nc_ht=scontent.xx&oh=858fa4a92d0e5b2d19a9e88cbe56c02e&oe=5E8CC849",
                  id: "18006711073033418"
                }
              ]
            },
            id: "17928268615244636"
          },
          {
            caption:
              "Natal vem chegando... Christmas is coming \ud83d\ude00\ud83c\udf85\ud83c\udffb\ud83c\udf84 #london #vgdicas #christmas #londonchristmas",
            comments_count: 0,
            like_count: 62,
            media_type: "IMAGE",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/46882562_1015670815271038_8907602394993815247_n.jpg?_nc_cat=109&_nc_oc=AQn0I2pkPNzfUFAtqDtMRXgyfo7-hfrYMKOK4IEVHv7q2nqyGyanb_a6jkM9cKECkqg&_nc_ht=scontent.xx&oh=cf1308285bd7ea3d80adbee62fb451fa&oe=5E5C00D8",
            shortcode: "Bq-Wb7XF3p3",
            permalink: "https://www.instagram.com/p/Bq-Wb7XF3p3/",
            timestamp: "2018-12-04T17:43:46+0000",
            id: "17915270557257391"
          },
          {
            caption:
              "Fazendo novos amigos em cada viagem \ud83d\udc2a #marrocos #desertodosaara #mochilaogol",
            comments_count: 6,
            like_count: 73,
            media_type: "IMAGE",
            media_url:
              "https://scontent.xx.fbcdn.net/v/t51.2885-15/45949929_367758017308635_7285288040349721344_n.jpg?_nc_cat=100&_nc_oc=AQlKtvuALE6JugoiTnWtWtbjy954do1irb-DCA8JB8HxQp8eEGz9YSD765YUIamF-MM&_nc_ht=scontent.xx&oh=edd005606303bda19ac4b51972f868ff&oe=5E409B5E",
            shortcode: "BqwnIZuFdkg",
            permalink: "https://www.instagram.com/p/BqwnIZuFdkg/",
            timestamp: "2018-11-29T09:40:17+0000",
            comments: {
              data: [
                {
                  username: "belejewellery",
                  text: "\ud83d\ude0d",
                  timestamp: "2019-02-27T02:29:34+0000",
                  id: "18009273067179231"
                },
                {
                  username: "aventurasnabagagem",
                  text: "Voc\u00ea parece pronto para correr. \ud83d\ude01",
                  timestamp: "2018-11-29T10:56:08+0000",
                  id: "17944720588201058"
                }
              ]
            },
            id: "17941101007220106"
          }
        ],
        paging: {
          cursors: {
            before:
              "QVFIUnQwc0tycUQ3NkdxSzJWYWFmc3ItbUtXTi1JVXdoSTFSUGl6YnptNWtpZAldwNndFNE5hRHVLaU5JYTV6MW9DbnQwa1BPUU94VE5uU0IxY0ZAtb05vNDNR",
            after:
              "QVFIUmpEUkFpbEpiNU9FS1lIRHhCZAnFPM1pkNllfdGVTQktLOW9EX1FZAUWFSYV9keVppSDZAVQzlRR2RubFRKelNpYzF3TVB1WmhzellDam1LczNJMnU0RF9B"
          },
          next:
            "https://graph.facebook.com/v4.0/17841406335072866/media?access_token=EAAcvR60qa88BABBRCi5Ncc5qhnblAp8h2xYBJUXhiaKQnbV7MoOZCQGAI4dtKcM5ywIlrgNlWhgulfDM4NXJSZCZCRz3FNZAYLcwFc68nj5VhZAT6Mwffhslh2UJjGS10r9n8MUo4EdfcLUnZACX5UtLrpZBbCzs5lREBTZCbhKjmQZDZD&fields=caption\u00252Ccomments_count\u00252Clike_count\u00252Cmedia_type\u00252Cmedia_url\u00252Cshortcode\u00252Cpermalink\u00252Ctimestamp\u00252Cchildren\u00257Bmedia_type\u00252Cmedia_url\u00257D\u00252Ccomments\u00257Busername\u00252Ctext\u00252Ctimestamp\u00257D&limit=25&after=QVFIUmpEUkFpbEpiNU9FS1lIRHhCZAnFPM1pkNllfdGVTQktLOW9EX1FZAUWFSYV9keVppSDZAVQzlRR2RubFRKelNpYzF3TVB1WmhzellDam1LczNJMnU0RF9B"
        }
      },
      loading: false
    };
  },
  mounted() {
    this.getPostsDummy();
  },
  computed: {
    ...mapFields(["selected"]),
    reloadPosts() {
      return this.$store.getters.reloadPosts;
    },
    token() {
      return this.$store.getters.facebook;
    },
    businessId() {
      return this.$store.getters.business;
    }
  },
  watch: {
    reloadPosts: function() {
      this.getPostsDummy();
      this.$store.dispatch("reloadPosts", false);
    }
  },
  methods: {
    toggleSelection(id) {
      this.$store.dispatch("addSelection", id);
    },
    loadMore() {
      this.completeData = Object.assign({}, this.postData, this.completeData);
      //this.posts = completeData;
    },
    getPostsDummy() {
      this.loading = true;
      this.posts = this.postData;
      this.loading = false;
    },
    getPosts() {
      this.loading = true;
      facebookApi
        .getPosts(this.businessId, this.token.authResponse.accessToken)
        .then(resp => {
          this.loading = false;
          this.posts = resp.data.data;
        });
    },
    truncate(input) {
      if (input.length > 25) return input.substring(0, 25) + "...";
      else return input;
    }
  }
};
</script>
<style>
.table-margin {
  margin-bottom: 100px;
}
.block {
  display: block;
}
.v-data-table__mobile-row__header {
  display: none;
}

.v-data-table__mobile-row__cell {
  text-align: left !important;
}
</style>
